import { Component, ElementRef, EventEmitter, Input, OnChanges, Output, output, SimpleChanges, ViewChild, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'card-graphic-small-component',
    templateUrl: './card-graphic-small.v2.component.html',
    // templateUrl: './card-graphic-small.component.html',
    styleUrls: ['./card-graphic-small.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CardGraphicSmallComponent {
  @ViewChild('container') container: ElementRef<HTMLDivElement>;
  @Input() total?: string;
  @Input() label?: string;
  /**
   * Optional secondary line under the label — e.g. the monetary equivalent of a
   * credit figure (SPEC-2026-08-typed-wallets RF-45). Renders only when set, so
   * every existing caller is unaffected.
   */
  @Input() description?: string;
  @Input() data?: string;
  @Input() icon?: string;
  @Input() iconClass?: string;
  @Input() tone?: string;
  @Input() descriptionTone?: string;

  /**@deprecated */
  @Input() graphicType?: string;
  /**@deprecated */
  @Input() contactInfoChart?: number;
  /**@deprecated */
  @Input() radius?: number;
  /**@deprecated */
  @Input() datasetTitle?: string;

  @Input() textColor?: string;
  @Input() totalContact?: number;

  @Input() isButton?: boolean = false;

  @Input() selectable?: boolean = false;
  @Input() selected?: boolean = false;


  showXAxis = true;
  showYAxis = false;
  gradient = true;
  showLegend = false;
  showXAxisLabel = false;
  xAxisLabel = '';
  showYAxisLabel = false;
  yAxisLabel = '';
  timeline = true;
  doughnut = true;
  colorScheme = {
    domain: ['#9370DB', '#87CEFA', '#FA8072', '#FF7F50', '#90EE90']
  };
  showLabels = true;

  public single = [
    {
      "name": "Seg",
      "value": 2243772
    },
    {
      "name": "Ter",
      "value": 1126000
    },
    {
      "name": "Qua",
      "value": 296215
    },
    {
      "name": "Qui",
      "value": 257363
    },
    {
      "name": "Sex",
      "value": 196750
    },

  ];

  get toneOrDefault(): string {
    return this.tone || 'primary';
  }

  onSelect(string) {
  }

  toggleSelection(): void {
    if (this.selectable) {
      this.selected = !this.selected;
    }
  }
}
